import { render, staticRenderFns } from "./BaseFilterExpander.vue?vue&type=template&id=24aebf6a&scoped=true&"
import script from "./BaseFilterExpander.vue?vue&type=script&lang=js&"
export * from "./BaseFilterExpander.vue?vue&type=script&lang=js&"
import style0 from "./BaseFilterExpander.vue?vue&type=style&index=0&id=24aebf6a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24aebf6a",
  null
  
)

export default component.exports